@if (name != null && name !== '') {
  <span
    class="pointer"
  (click)="
    $event.stopPropagation();
    $event.preventDefault();
    app.profile.initProfile(id);
    "
    [title]="app.text.credits.open"
    >
    &nbsp;{{ app.users.getOptionName(name) }} &nbsp;
  </span>
}
@if (name === '') {
  <span>
    {{ app.text.credits.unknown }}
  </span>
}
